<script>
import axios from 'axios'
import Form from '@/src/classes/Form'
import Mfa from '../mfa/mfa.vue'
import CustomSnackbar from '@components/custom-snackbar.vue'

export default {
  page: {
    title: 'Security Settings',
    meta: [
      { name: 'description', content: 'The Safehaven Security Settings page.' },
    ],
  },
  components: { Mfa, CustomSnackbar },
  data() {
    return {
      form: new Form({
        oldpassword: '',
        password: '',
      }),
      message: '',
      passwordConfirm: '',
      changeError: null,
      factorAuth: true,
      visibility: 'mdi-eye',
      visibilityOff: 'mdi-eye-off',
      passwordType: 'password',
      passwordNewType: 'password',
      passwordConfirmType: 'password',

      oldPasswordRule: [(v) => ''],
      passwordPattern: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-])\S{8,}$/,
      passwordRules: [
        (v) =>
          this.passwordPattern.test(v) ||
          'Passwords must contain at least 8 characters with uppercase and lowercase, a number and a special character.',
      ],
      confirmRules: [
        (v) => (v && this.matchingPasswords) || 'Passwords do not match',
      ],
      snackbar: false,
      snackbarMessage: '',
    }
  },
  computed: {
    iconType() {
      return this.passwordType === 'password'
        ? this.visibilityOff
        : this.visibility
    },
    iconNewType() {
      return this.passwordNewType === 'password'
        ? this.visibilityOff
        : this.visibility
    },
    iconConfirmType() {
      return this.passwordConfirmType === 'password'
        ? this.visibilityOff
        : this.visibility
    },
    matchingPasswords() {
      if (
        this.form.password !== '' &&
        this.passwordConfirm !== '' &&
        this.form.password === this.passwordConfirm &&
        this.passwordPattern.test(this.form.password)
      ) {
        this.$emit('set-password', this.form.password)
        return true
      } else {
        return false
      }
    },
    success() {
      return (
        !!this.form.password &&
        !!this.passwordConfirm &&
        this.changeError === null &&
        this.passwordConfirm === this.form.password
      )
    },
    successMessage() {
      if (
        this.form.password !== '' &&
        this.passwordConfirm !== '' &&
        this.changeError === null &&
        this.passwordConfirm === this.form.password
      ) {
        return ['Passwords match']
      } else {
        return []
      }
    },
    disableBtn() {
      if (
        this.form.oldpassword.trim() &&
        this.form.password === this.passwordConfirm &&
        (this.form.password !== '' || this.passwordConfirm !== '')
      ) {
        return false
      } else {
        return true
      }
    },
    canShowErrorMessage() {
      return (
        this.changeError &&
        typeof this.changeError.response.data === 'string' &&
        this.changeError.response.data === 'Incorrect old password'
      )
    },

    canShowErrorMessageSame() {
      return (
        this.changeError &&
        typeof this.changeError.response.data === 'string' &&
        this.changeError.response.data !== 'Incorrect old password'
      )
    },
  },
  watch: {
    passwordConfirm(val) {
      this.$refs.pass.validate()
    },
    password(val) {
      this.$refs.conPass.validate()
    },
  },
  methods: {
    toggleType() {
      this.passwordType = this.passwordType === 'text' ? 'password' : 'text'
    },
    toggleNewType() {
      this.passwordNewType =
        this.passwordNewType === 'text' ? 'password' : 'text'
    },
    toggleConfirmType() {
      this.passwordConfirmType =
        this.passwordConfirmType === 'text' ? 'password' : 'text'
    },
    resetForm() {
      this.$refs.form.resetValidation()
      this.$refs.form.reset()
      this.form.password = ''
      this.passwordConfirm = ''
      this.form.oldpassword = ''
      this.changeError = null
      this.message = null
    },
    async changePassword() {
      this.message = null
      this.changeError = null

      try {
        const response = await axios.post('/api/v1/password-change/', {
          password: this.form.oldpassword,
          new_password: this.form.password,
          confirm_password: this.passwordConfirm,
        })

        if (response) {
          this.changeError = null
          this.$refs.form.resetValidation()
          document.getElementById('confirmPasswordId').click()
          this.message = 'Your password has been changed!'
          this.snackbarMessage = 'Your password has been changed!'
          this.snackbar = true
          setTimeout(() => {
            this.snackbar = false
          }, 3000)
        }
      } catch (error) {
        this.changeError = error
        this.form.onFail(error.response.data)
      }
    },
    clearFormFromErrors(eventName) {
      this.changeError = null
      this.form.errors.clear(eventName)
    },
  },
}
</script>

<template>
  <v-form
    ref="form"
    lazy-validation
    :class="$style.form"
    @submit.prevent="changePassword"
  >
    <v-container>
      <v-row>
        <v-col cols="12" md="8">
          <label>Old Password<span :class="$style.mandatory">*</span> </label>
          <v-text-field
            key="password"
            ref="oldpass"
            v-model="form.oldpassword"
            name="oldpass"
            hide-details="auto"
            :type="passwordType"
            :error="canShowErrorMessage"
            :success-messages="[]"
            autocomplete="off"
            outlined
            :append-icon="iconType"
            @click:append="toggleType"
            @keydown="clearFormFromErrors($event.target.name)"
            @keyup="message = null"
          ></v-text-field>
          <div
            v-if="canShowErrorMessage"
            class="mt-5"
            :class="$style.Errorvalidation"
            role="alert"
          >
            {{ changeError.response.data }}
          </div>
        </v-col>

        <v-col cols="12" md="8">
          <label>New Password<span :class="$style.mandatory">*</span> </label>
          <v-text-field
            key="password"
            ref="pass"
            v-model="form.password"
            name="pass"
            hide-details="auto"
            :type="passwordNewType"
            :rules="form.password ? passwordRules : []"
            :error="passwordConfirm !== '' && !matchingPasswords"
            :error-messages="[]"
            :success="success"
            :success-messages="[]"
            autocomplete="off"
            outlined
            :append-icon="iconNewType"
            @click:append="toggleNewType"
            @keydown="clearFormFromErrors($event.target.name)"
            @keyup="message = null"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="8">
          <label
            >Confirm Password<span :class="$style.mandatory">*</span>
          </label>
          <v-text-field
            id="confirmPasswordId"
            key="confirmPassword"
            ref="conPass"
            v-model="passwordConfirm"
            name="con"
            hide-details="auto"
            :type="passwordConfirmType"
            autocomplete="off"
            :success="success"
            :success-messages="successMessage"
            outlined
            :rules="
              passwordConfirm !== '' && passwordConfirm !== form.password
                ? confirmRules
                : []
            "
            :append-icon="iconConfirmType"
            @click:append="toggleConfirmType"
            @keydown="clearFormFromErrors($event.target.name)"
            @keyup="message = null"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn
            :class="[
              'primary-btn',
              disableBtn && 'disabled-btn',
              $vuetify.breakpoint.mobile && 'full-width-btn',
            ]"
            type="submit"
          >
            Update
          </v-btn>
          <v-btn
            text
            color="primary"
            :class="$style.cancelText"
            @click="resetForm"
            >Cancel</v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div
            v-if="canShowErrorMessageSame"
            class="mt-5"
            :class="$style.Errorvalidation"
            role="alert"
          >
            {{ changeError.response.data }}
          </div>
        </v-col>
      </v-row>
      <Mfa></Mfa>
      <div>
        <CustomSnackbar
          :snackbar="snackbar"
          :snackbar-message="snackbarMessage"
        />
      </div>
    </v-container>
  </v-form>
</template>

<style lang="scss" module>
@import '@design';

.mandatory {
  color: #da1414;
}
.form label {
  display: inline-block;
  margin-bottom: 10px;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  color: #454648;
  letter-spacing: 0.2px;
}

.updateButtonClass {
  width: 120px;
  height: 45px !important;
  margin-left: 8px;
  text-transform: inherit !important;
  background: #0476d9;
  border-radius: 30px;
}

.cancelText {
  width: 120px;
  height: 45px !important;
  text-transform: none;
  border-radius: 30px;
}

.Errorvalidation {
  font-size: small;
  line-height: 14px;
  color: #ca024f;
  text-align: left;
}

.message {
  margin-top: 8px;
  margin-left: 12px;
  font-size: 12px;
  color: #42ac53;
}
@media screen and (max-width: 959px) {
  .form label {
    font-size: 11px;
  }
}
@media screen and (max-width: 599px) {
  .updateButtonClass,
  .cancelText {
    width: 100% !important;
    margin-bottom: 15px;
    margin-left: 1px;
  }
}
</style>

<style scoped>
/deep/ .v-input--selection-controls__input + .v-label {
  margin-top: 10px;
  margin-left: 5px;
}

/deep/ .theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  color: #fff !important;
  background-color: #93c0e8 !important;
}

/deep/ .v-text-field--outlined > .v-input__control > .v-input__slot {
  background: #fff;
}
</style>
